import { render, staticRenderFns } from "./CellGrid.vue?vue&type=template&id=6b243027&"
import script from "./CellGrid.vue?vue&type=script&lang=ts&"
export * from "./CellGrid.vue?vue&type=script&lang=ts&"
import style0 from "./CellGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
